/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Purpose_BuiltInputs */

const en_nfp_purpose_built = /** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purpose-Built Infrastructure`)
};

const es_nfp_purpose_built = /** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestructura Específica`)
};

const fr_nfp_purpose_built = /** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure conçue sur mesure`)
};

const de_nfp_purpose_built = /** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speziell entwickelte Infrastruktur`)
};

const id_nfp_purpose_built = /** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktur Dirancang Khusus`)
};

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const ja_nfp_purpose_built = en_nfp_purpose_built;

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const zh_nfp_purpose_built = en_nfp_purpose_built;

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const ar_nfp_purpose_built = en_nfp_purpose_built;

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const it_nfp_purpose_built = en_nfp_purpose_built;

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const ru_nfp_purpose_built = en_nfp_purpose_built;

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const pt_nfp_purpose_built = en_nfp_purpose_built;

/** @type {(inputs: Nfp_Purpose_BuiltInputs) => LocalizedString} */
const ko_nfp_purpose_built = en_nfp_purpose_built;

/**
* | output |
* | --- |
* | "Purpose-Built Infrastructure" |
*
* @param {Nfp_Purpose_BuiltInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_purpose_built = /** @type {((inputs?: Nfp_Purpose_BuiltInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Purpose_BuiltInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_purpose_built(inputs)
	if (locale === "es") return es_nfp_purpose_built(inputs)
	if (locale === "fr") return fr_nfp_purpose_built(inputs)
	if (locale === "de") return de_nfp_purpose_built(inputs)
	if (locale === "ja") return ja_nfp_purpose_built(inputs)
	if (locale === "zh") return zh_nfp_purpose_built(inputs)
	if (locale === "ar") return ar_nfp_purpose_built(inputs)
	if (locale === "id") return id_nfp_purpose_built(inputs)
	if (locale === "it") return it_nfp_purpose_built(inputs)
	if (locale === "ru") return ru_nfp_purpose_built(inputs)
	if (locale === "pt") return pt_nfp_purpose_built(inputs)
	return ko_nfp_purpose_built(inputs)
});